import { LoaderTheme } from '@/components/Loader/theme';
import { GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: LoaderTheme });

const Base = $({ as: 'div', slot: 'base' });

export const Loader = Object.assign(Base, {});
